var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import "./style.scss";
export var thumbnailBadge = function (index, badges, badgeDetails, bigImgSize, badgeStyles, thumbnailType, contentId, layoutSettings) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (badges === void 0) { badges = []; }
    if (badgeDetails === void 0) { badgeDetails = ''; }
    if (bigImgSize === void 0) { bigImgSize = false; }
    if (badgeStyles === void 0) { badgeStyles = {}; }
    if (contentId === void 0) { contentId = ''; }
    if (layoutSettings === void 0) { layoutSettings = {}; }
    var hoverEffect = (layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.hoverEffect) || 'zoomIn';
    var isVisible = (badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.visible) || '';
    if (!badgeDetails || !isVisible) {
        return;
    }
    var badgeTypeImageArray = badges.filter(function (badge) { return badge.type === 'IMAGE'; });
    var isBadgeTypeImage = ((_a = badgeTypeImageArray[index]) === null || _a === void 0 ? void 0 : _a.type) || null;
    if (isBadgeTypeImage === 'IMAGE') {
        var imPolicy = thumbnailType !== "portrait" ? "?impolicy=resize&w=".concat(1000, "&h=").concat(1000 * (0.5625)) : "?impolicy=resize&w=".concat(305, "&h=").concat(305 * (1.48));
        var imgSrcKey = '';
        if (thumbnailType) {
            if (thumbnailType === 'landscape') {
                imgSrcKey = 'r16x9';
            }
            else {
                imgSrcKey = ("r" + thumbnailType.replace('*', 'x'));
            }
        }
        else {
            imgSrcKey = 'r16x9';
        }
        var imgSrc = imgSrcKey && ((_b = badgeTypeImageArray[index]) === null || _b === void 0 ? void 0 : _b.images) && ((_c = badgeTypeImageArray[index]) === null || _c === void 0 ? void 0 : _c.images[imgSrcKey]);
        var badgeTitle = ((_d = badgeTypeImageArray === null || badgeTypeImageArray === void 0 ? void 0 : badgeTypeImageArray[index]) === null || _d === void 0 ? void 0 : _d.title) || "Badge";
        if (imgSrc) {
            return React.createElement("div", { key: index, className: "badge-image" },
                React.createElement("img", { style: { borderColor: hoverEffect === "border" ? (layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.hoverItemBorderColor) || "#ffffff" : "" }, role: "none", src: imgSrc + imPolicy, className: "badgeImg" }));
        }
        return;
    }
    var title = (badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.title) || '';
    var alignment = (badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.alignment) || 'TopRight';
    var backgroundColor = ((_e = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _e === void 0 ? void 0 : _e.backgroundColor) || 'transparent';
    var gradientColor = ((_f = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _f === void 0 ? void 0 : _f.gradientColor) || 'transparent';
    var textColor = ((_g = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _g === void 0 ? void 0 : _g.textColor) || '#ffffff';
    var borderColor = ((_h = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _h === void 0 ? void 0 : _h.borderColor) || '#ffffff';
    var borderWidth = ((_j = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _j === void 0 ? void 0 : _j.borderWidth) || '0px';
    var textStyle = ((_k = badgeDetails === null || badgeDetails === void 0 ? void 0 : badgeDetails.style) === null || _k === void 0 ? void 0 : _k.textStyle) || [];
    var fontWeight, fontStyle, textDecoration;
    fontWeight = 'normal';
    fontStyle = 'normal';
    textDecoration = 'none';
    if ((textStyle === null || textStyle === void 0 ? void 0 : textStyle.length) > 0 && (textStyle === null || textStyle === void 0 ? void 0 : textStyle.includes('bold'))) {
        fontWeight = 'bold';
    }
    if ((textStyle === null || textStyle === void 0 ? void 0 : textStyle.length) > 0 && (textStyle === null || textStyle === void 0 ? void 0 : textStyle.includes('italic'))) {
        fontStyle = 'italic';
    }
    if ((textStyle === null || textStyle === void 0 ? void 0 : textStyle.length) > 0 && (textStyle === null || textStyle === void 0 ? void 0 : textStyle.includes('underline'))) {
        textDecoration = 'underline';
    }
    var verticalGap = false;
    var firstBadgeAlignment = (badges === null || badges === void 0 ? void 0 : badges.length) > 1 && badges[0].alignment || '';
    var secondBadgeAlignment = (badges === null || badges === void 0 ? void 0 : badges.length) > 1 && badges[1].alignment || '';
    if (index && (firstBadgeAlignment == secondBadgeAlignment)) { // If both badges have the same alignment
        verticalGap = true; //verticalGap should be 25px
    }
    else if (index && bigImgSize === false && (firstBadgeAlignment.includes('Center') || secondBadgeAlignment.includes('Center')) && (firstBadgeAlignment.replace(/left|right|center/gi, '') == secondBadgeAlignment.replace(/left|right|center/gi, ''))) { // If any badge has the center alignment
        verticalGap = true;
    }
    else {
        verticalGap = false;
    }
    var left, right, top, bottom, transform;
    switch (alignment) {
        case "bottomCenter":
            top = 'auto';
            bottom = verticalGap ? "calc(25px + 4%)" : "2%";
            left = "50%";
            right = bigImgSize ? "auto" : "auto";
            transform = 'translateX(-55%)';
            break;
        case "bottomLeft":
            top = 'auto';
            bottom = verticalGap ? "calc(25px + 4%)" : "2%";
            left = "2%";
            right = "auto";
            transform = 'none';
            break;
        case "bottomRight":
            top = 'auto';
            bottom = verticalGap ? "calc(25px + 4%)" : "2%";
            left = "auto";
            right = bigImgSize ? "5%" : "2%";
            transform = 'none';
            break;
        case "topCenter":
            top = verticalGap ? "calc(25px + 4%)" : "2%";
            bottom = "auto";
            left = "50%";
            right = bigImgSize ? "auto" : "auto";
            transform = 'translateX(-55%)';
            break;
        case "topLeft":
            top = verticalGap ? "calc(25px + 4%)" : "2%";
            bottom = "auto";
            left = "2%";
            right = "auto";
            transform = 'none';
            break;
        case "topRight":
            top = verticalGap ? "calc(25px + 4%)" : "2%";
            bottom = "auto";
            left = "auto";
            right = bigImgSize ? "5%" : "2%";
            transform = 'none';
            break;
        default:
            top = verticalGap ? "calc(25px + 4%)" : "2%";
            bottom = "auto";
            left = "auto";
            right = bigImgSize ? "5%" : "2%";
            transform = 'none';
            break;
    }
    return React.createElement("div", { key: index, className: "badge-text", style: __assign({ 'background': "linear-gradient(".concat(backgroundColor, ", ").concat(gradientColor, ")"), inset: "".concat(top, " ").concat(right, " ").concat(bottom, " ").concat(left), color: textColor, border: "".concat(borderWidth, " solid ").concat(borderColor), transform: transform }, badgeStyles) }, title);
};
